import React from "react";
import { Link } from "react-router-dom";

export const LoginForm = ({
  email, setEmail, password, setPassword, busy, onSubmit, onGoogle,
}) => (
  <form onSubmit={onSubmit} className="w-full max-w-md space-y-5" data-testid="auth-form">
    <div>
      <h1 className="font-display font-bold text-3xl text-[#0B2B62] tracking-tight">Entrar</h1>
      <p className="text-sm text-slate-500 mt-1">Acesse seus atendimentos e continue de onde parou.</p>
    </div>

    <div>
      <label className="text-sm font-medium text-slate-700">E-mail</label>
      <input data-testid="input-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
        className="mt-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-md focus:ring-2 focus:ring-[#0B2B62] focus:border-transparent outline-none" />
    </div>

    <div>
      <label className="text-sm font-medium text-slate-700">Senha</label>
      <input data-testid="input-password" required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
        className="mt-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-md focus:ring-2 focus:ring-[#0B2B62] focus:border-transparent outline-none" />
    </div>

    <button data-testid="submit-auth" disabled={busy} type="submit"
      className="w-full py-3 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 transition-colors disabled:opacity-60">
      {busy ? "Aguarde..." : "Entrar"}
    </button>

    <div className="relative py-2">
      <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-200" /></div>
      <div className="relative flex justify-center text-xs uppercase tracking-widest">
        <span className="bg-white px-3 text-slate-400">ou</span>
      </div>
    </div>
    <button type="button" data-testid="google-login-btn" onClick={onGoogle}
      className="w-full py-3 border border-slate-300 bg-white text-slate-700 rounded-md font-semibold hover:bg-slate-50 transition-colors flex items-center justify-center gap-2">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.7 2.5 30.2 0 24 0 14.8 0 6.9 5.2 3 12.9l7.8 6.1C12.6 13.7 17.8 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9.4h12.7c-.6 3-2.3 5.5-4.9 7.2l7.6 5.9c4.4-4.1 7.1-10.1 7.1-17.8z"/><path fill="#FBBC05" d="M10.8 28.9c-.5-1.4-.8-2.9-.8-4.4s.3-3 .8-4.4l-7.8-6.1C1.1 17.2 0 20.5 0 24s1.1 6.8 3 9.9l7.8-5z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.6-5.9c-2.1 1.4-4.8 2.3-8.3 2.3-6.2 0-11.4-4.2-13.2-9.9L3 33.9C6.9 42.8 14.8 48 24 48z"/></svg>
      Entrar com Google
    </button>

    <div className="text-center text-sm text-slate-600">
      Ainda não tem conta? <Link to="/cadastro" className="text-[#0B2B62] font-semibold hover:underline">Cadastre-se</Link>
    </div>
    <div className="text-center">
      <Link to="/esqueci-minha-senha" data-testid="forgot-link" className="text-xs text-slate-500 hover:text-[#0B2B62] hover:underline">Esqueci minha senha</Link>
    </div>
  </form>
);
